import React from 'react'
import schema from '../jsonschemas/infrastructure_support/infrastructure_support.json'
import uiSchema from '../jsonschemas/infrastructure_support/web_ui_schema.json'
import { FormPreview } from './FormPreview'

export function TestSchema5() {
  return <FormPreview schema={schema} uiSchema={uiSchema} />
}
